import React, { useState } from "react";
import Eligibility from "./Eligibility/Index";
import Estimator from "./Estimator/Index";
import Tailor from "./Tailor/Index";
import Insights from "./Insights/Index";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet-async";

const Index = () => {
  const location = useLocation();
  const pathname = location.pathname;

  const [pageType, setPageType] = useState(() => {
    if (pathname === "/personalloan/check-eligibility/dashboard") {
      return "pl";
    } else {
      return "cl";
    }
  });

  return (
    <>
      <Helmet>
        {pathname === "/personalloan/check-eligibility/dashboard" && (
          <title>Personal Loan Eligibility Dashboard - Minemi</title>
        )}
        {pathname === "/carloan/check-eligibility/dashboard" && (
          <title>Car Loan Eligibility Dashboard - Minemi</title>
        )}
      </Helmet>
      <Eligibility pageType={pageType} />
      <Estimator pageType={pageType} />
      <Tailor pageType={pageType} />
      <Insights pageType={pageType} />
      {/* <Footer /> */}
    </>
  );
};

export default Index;
